import React, { useState } from "react";
import "./PageThree.css";
import { useTranslation } from 'react-multi-lang';


const PageThree = ({ onButtonClick }) => {
  const t = useTranslation();

  return (
    <main
      className="pagethree"
      style={{ maxWidth: "50%", maxHeight: "25%", margin: "50px auto", textAlign: "center" ,marginTop:"50px"}}
    >
      <div className="sa-icon sa-success animate" >
        <span className="sa-line sa-tip animateSuccessTip"></span>
        <span className="sa-line sa-long animateSuccessLong"></span>

        <div className="sa-placeholder"></div>
        <div className="sa-fix"></div>
      </div>
      <h2 className=" font-bold">{t("Reclamation.success")}</h2>
    </main>
  );
}

export default PageThree;